import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  FinanceIcon,
  AccountsReceivable1,
  AccountsReceivable2,
  AccountsReceivable3,
  AccountsPayable1,
  AccountsPayable2,
  AccountsPayable3,
  TaxationControls1,
  TaxationControls2,
  TaxationControls6,
} from '../../assets';

const FinancePageUAE = () => {
  const productData = {
    productName: 'Finance',
    tagline: 'Multi-currency Freight Finance Software for UAE Operations',
    metaDescription: 'Freight finance software for UAE and Gulf freight forwarders: multi-currency invoicing (AED, USD, EUR), per-shipment P&L, accounts payable management, approval workflows, and bank reconciliation in one platform.',
    description: 'Take full control of your freight financials: from multi-currency invoicing to per-shipment profitability tracking, accounts payable, configurable approval workflows, and bank reconciliation. Built for UAE and Gulf freight forwarding operations.',
    icon: FinanceIcon,
    pageUrlOverride: 'https://shipmnts.com/uae/products/finance',
    currency: 'USD',
    features: [
      {
        title: 'Integrated Invoicing from Shipments',
        description: 'Generate invoices automatically from shipment data with accurate charge breakdowns across AED, USD, EUR, and other currencies.',
        image: AccountsReceivable1,
      },
      {
        title: 'Automated Collection Reminders',
        description: 'Send automated payment reminders and track collection status across your UAE and Gulf client base.',
        image: AccountsReceivable2,
      },
      {
        title: 'AR with Profitability Insights',
        description: 'Track receivables with built-in profitability analysis per customer, shipment, and trade lane.',
        image: AccountsReceivable3,
      },
      {
        title: 'Integrated Purchase Invoice Posting',
        description: 'Match vendor invoices with shipment costs and post to accounts payable: eliminating manual reconciliation.',
        image: AccountsPayable1,
      },
      {
        title: 'Bulk Purchase Booking System',
        description: 'Book multiple vendor invoices in bulk with automated validation and matching.',
        image: AccountsPayable2,
      },
      {
        title: 'AP Tracking & Monitoring',
        description: 'Track payables aging, payment schedules, and vendor performance across currencies.',
        image: AccountsPayable3,
      },
      {
        title: 'Multi-currency Compliance & Reporting',
        description: 'Manage invoices and reports across AED, USD, EUR, and other currencies with accurate exchange rate tracking.',
        image: TaxationControls1,
      },
      {
        title: 'Profit and Loss with EBITDA Metrics',
        description: 'View real-time P&L statements with EBITDA tracking per shipment, branch, and business vertical.',
        image: TaxationControls2,
      },
      {
        title: 'Bank Reconciliation Suite',
        description: 'Reconcile bank statements automatically with matching algorithms: Kotak live, more banks on the roadmap.',
        image: TaxationControls6,
      },
    ],
    faqs: [
      {
        question: 'Does Shipmnts support multi-currency invoicing for UAE freight operations?',
        answer: 'Yes. Shipmnts supports multi-currency invoicing including AED, USD, EUR, and other major currencies: with accurate exchange rate tracking across receivables and payables. Essential for UAE freight forwarders transacting across multiple trade lanes.',
      },
      {
        question: 'Can Shipmnts generate invoices automatically from shipment data?',
        answer: 'Yes. Shipmnts integrates billing directly with shipment operations: invoices are generated from job data with accurate charge breakdowns, eliminating manual re-entry and reducing billing errors.',
      },
      {
        question: 'Can I track profitability per shipment in Shipmnts?',
        answer: 'Yes. Shipmnts provides per-job P&L visibility with EBITDA-level metrics, letting you see revenue, costs, and margin on every shipment in real time: across currencies and branches.',
      },
      {
        question: 'Does Shipmnts support configurable approval workflows for invoices?',
        answer: 'Yes. Shipmnts includes configurable approval workflows for invoices and payments: set by branch and role. Finance teams can review and approve before release, with credit control policies that hold document releases for high-risk customers.',
      },
      {
        question: 'Does Shipmnts have bank reconciliation?',
        answer: 'Yes. Shipmnts includes a bank reconciliation suite that matches bank statement entries against invoices and payments automatically, flagging unmatched items for review.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default FinancePageUAE;
